import React, {useEffect, useRef, useState} from 'react';
import styles from './Form.module.css';
import logoLarge from "./logoLarge.png";
import logoSmall from "./logoSmall.png";
import {Menu} from "primereact/menu";
import {useLocation, useNavigate} from "react-router-dom";
import {Button} from "primereact/button";
import SearchPanel from "../trip/search-panel/SearchPanel";
import PanelForm from "../panel/Form";


import ImageBeliebt from "./assets/Beliebt.png"
import ImageAlle from "./assets/Alle.png"
import ImageSpanaien from "./assets/50ppi/Spanaien.png"
import ImageEngland from "./assets/50ppi/England.png"
import ImageFrankreich from "./assets/50ppi/Frankreich.png"
import ImageItalien from "./assets/50ppi/Italien.png"
import ImageChina from "./assets/50ppi/China.png"
import ImageJapan from "./assets/50ppi/Japan.png"
import ImageYoga from "./assets/Yoga.png"
import ImageAchtsamkeit from "./assets/Achtsamkeit.png"
import ImageKommunikation from "./assets/Kommunikation.png"
import ImageSonstiges from "./assets/Sonstiges.png"



export default function Form(props) {

    const location = useLocation();

    const navigate = useNavigate();
    const menu = useRef();


    const containerRef = useRef(null)
    const div1Ref = useRef(null);
    const div2Ref = useRef(null);


    const [items, setItems] = useState([
        {label: 'Über uns', command:() => navigate("/ueberuns")},
        {label: 'FAQ', command:() => navigate("/faq")},
        {label: 'Buchung aufrufen', command:() => navigate("/bookings")}
    ]);


    useEffect(() => {
        const observer = new ResizeObserver(([entry]) => {
            const height = entry.contentRect.height;

            if (div2Ref.current) {
                div2Ref.current.style.height = `${height}px`;
            }
        });

        if (div1Ref.current) {
            observer.observe(div1Ref.current);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if(location.pathname !== "/" && props.isXl === false) {
            props.setSearchSwitch("readPanel")
        }
    }, [location.pathname]);

    return (
        <div>

            <div ref={containerRef} className={styles.root}>

                <div ref={div1Ref} className={styles.wrapper} style={{padding: '0px 30px'}}>
                    <div className="hidden xl:flex flex-row" style={{paddingBottom: '15px'}}>

                        <div style={{width: '250px', textAlign: 'right', padding: '10px 20px'}}>
                            <img src={logoLarge} style={{height: '75px', cursor: 'pointer'}} onClick={() => navigate("/")}/>
                        </div>

                        <div className="flex-auto">
                            <div className="flex flex-column">

                                <div style={{padding: '20px 50px 10px 0px', textAlign: 'right'}}>
                                    {items.map( item => (
                                        <React.Fragment>
                                            {item.label !== 'Buchung aufrufen' && (
                                                <span
                                                    onClick={item.command}
                                                    className={styles.item}>
                                                    {item.label}
                                                </span>
                                            )}
                                            {item.label === 'Buchung aufrufen' && (
                                                <Button
                                                    icon="pi pi-user"
                                                    label={item.label}
                                                    onClick={item.command}
                                                    style={{
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        marginBottom: -8,
                                                        background: 'transparent',
                                                        color: '#004858',
                                                        borderColor: '#004858'}}/>
                                            )}
                                        </React.Fragment>

                                    ))}
                                </div>
                                <div style={{paddingRight: '250px', paddingTop: '15px'}}>
                                    <center>
                                        <div style={{maxWidth: '800px'}}>
                                            <SearchPanel
                                                isXL={props.isXL}
                                                onSearch={(search) => props.setSearchSwitch("readPanel")}
                                                searchSwitch = {props.searchSwitch}
                                                setProgress={(progress) => props.setProgress(progress)}
                                                trips={props.trips}
                                                setTrips={(trips) => props.setTrips(trips)}
                                                selectedFavorite={props.selectedFavorite}
                                                setSelectedFavorite={(selectedFavorite) => props.setSelectedFavortie(selectedFavorite)}
                                                selectedState={props.selectedState}
                                                setSelectedState={(selectedState) => props.setSelectedState(selectedState)}
                                                selectedLanguage={props.selectedLanguage}
                                                setSelectedLanguage={(selectedLanguage) => props.setSelectedLanguage(selectedLanguage)}
                                                selectedSuitableFor={props.selectedSuitableFor}
                                                setSelectedSuitableFor={(selectedSuitableFor) => props.setSelectedSuitableFor(selectedSuitableFor)}
                                                selectedAppointmentLength={props.selectedAppointmentLength}
                                                setSelectedAppointmentLength={(selectedAppointmentLength) => props.setSelectedAppointmentLength(selectedAppointmentLength)}
                                                selectedLocation={props.selectedLocation}
                                                setSelectedLocation={(selectedLocation) => props.setSelectedLocation(selectedLocation)}
                                                selectedAppointment={props.selectedAppointment}
                                                setSelectedAppointment={(selectedAppointment) => props.setSelectedAppointment(selectedAppointment)}/>
                                        </div>
                                    </center>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="xl:hidden">
                        <table style={{width: '100%', height: '125px'}}>
                            <tbody>
                            <tr>
                                <td style={{verticalAlign: 'top', width: '150px'}}>
                                    <img src={logoSmall} style={{height: '75px', cursor: 'pointer'}} onClick={() => navigate("/")}/>
                                </td>
                                <td style={{verticalAlign: 'top'}}>

                                </td>
                                <td style={{verticalAlign: 'top', width: '150px', textAlign: 'right', paddingTop: "30px"}}>
                                    <Menu
                                        appendTo={containerRef.current}
                                        model={items}
                                        popup
                                        ref={menu} id="popup_menu"/>
                                    <Button
                                        icon="pi pi-bars"
                                        onClick={(event) => {
                                            console.log(menu)
                                            menu.current.toggle(event)
                                        }}
                                        aria-controls="popup_menu"
                                        aria-haspopup />
                                </td>
                            </tr>
                            <tr>

                                <td colSpan={3} style={{verticalAlign: 'top'}}>
                                    {props.searchSwitch === "searchPanel" && (

                                        <SearchPanel
                                            setProgress={(progress) => props.setProgress(progress)}
                                            onSearch={(search) => props.setSearchSwitch("readPanel")}
                                            searchSwitch = {props.searchSwitch}
                                            trips={props.trips}
                                            setTrips={(trips) => props.setTrips(trips)}
                                            selectedFavorite={props.selectedFavorite}
                                            setSelectedFavorite={(selectedFavorite) => props.setSelectedFavortie(selectedFavorite)}
                                            selectedState={props.selectedState}
                                            setSelectedState={(selectedState) => props.setSelectedState(selectedState)}
                                            selectedLanguage={props.selectedLanguage}
                                            setSelectedLanguage={(selectedLanguage) => props.setSelectedLanguage(selectedLanguage)}
                                            selectedSuitableFor={props.selectedSuitableFor}
                                            setSelectedSuitableFor={(selectedSuitableFor) => props.setSelectedSuitableFor(selectedSuitableFor)}
                                            selectedAppointmentLength={props.selectedAppointmentLength}
                                            setSelectedAppointmentLength={(selectedAppointmentLength) => props.setSelectedAppointmentLength(selectedAppointmentLength)}
                                            selectedLocation={props.selectedLocation}
                                            setSelectedLocation={(selectedLocation) => props.setSelectedLocation(selectedLocation)}
                                            selectedAppointment={props.selectedAppointment}
                                            setSelectedAppointment={(selectedAppointment) => props.setSelectedAppointment(selectedAppointment)}/>
                                    )}
                                    {props.searchSwitch === "readPanel" && (

                                        <div>
                                            <PanelForm style={{background: 'rgba(255,255,255)'}}>
                                                <div className="flex-auto" style={{padding: '10px 20px', fontSize: '9px', whiteSpace: 'nowrap'}}>
                                                    <div className="flex flex-row">
                                                        <div>
                                                            <Button icon="pi pi-angle-left" onClick={() => props.setSearchSwitch("searchPanel")}/>
                                                        </div>

                                                        <div className="flex-1" style={{paddingLeft: '10px'}}>
                                                            <div style={{fontWeight: 'bold'}}>Anerkannt für:</div>
                                                            {props?.selectedState.name}
                                                        </div>
                                                        <div className="flex-1" style={{paddingLeft: '10px'}}>
                                                            <div style={{fontWeight: 'bold'}}>Sprache:</div>
                                                            {props?.selectedLanguage.name}
                                                        </div>
                                                        <div className="flex-1" style={{paddingLeft: '10px'}}>
                                                            <div style={{fontWeight: 'bold'}}>Dauer:</div>
                                                            {props?.selectedAppointmentLengths}
                                                        </div>
                                                        <div className="flex-1" style={{paddingLeft: '10px'}}>
                                                            <div style={{fontWeight: 'bold'}}>Wohin:</div>
                                                            {props?.selectedLocation}
                                                        </div>
                                                        <div className="flex-1" style={{paddingLeft: '10px'}}>
                                                            <div style={{fontWeight: 'bold'}}>Startdatum:</div>
                                                            {props?.selectedAppointment}
                                                        </div>

                                                    </div>
                                                </div>
                                            </PanelForm>


                                        </div>
                                    )}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>


                    <div style={{background: 'linear-gradient(to right, transparent, white, transparent)'}}>
                        <div className="wrapper">
                            <div className="flex flex-wrap" style={{textAlign: 'center', justifyContent: 'center'}}>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(!props.selectedFavorite)
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageBeliebt} style={{height: '20px'}}/>
                                    <div style={props.selectedFavorite ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Beliebt
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedSuitableFor(null)
                                        props.setSelectedLanguage({code: null, label: "Alle"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageAlle} style={{height: '20px'}}/>
                                    <div style={props.selectedFavorite === false && props.selectedLanguage?.code === null && props.selectedSuitableFor === null ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Alle
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedLanguage({code: "ES", label: "Spanisch"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageSpanaien} style={{height: '20px'}} />
                                    <div style={props.selectedLanguage?.code === "ES" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Spanisch
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedLanguage({code: "GB", label: "Englisch"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageEngland} style={{height: '20px'}}/>
                                    <div style={props.selectedLanguage?.code === "GB" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Englisch
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedLanguage({code: "FR", label: "Französisch"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageFrankreich} style={{height: '20px'}}/>
                                    <div style={props.selectedLanguage?.code === "FR" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Französisch
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedLanguage({code: "IT", label: "Italienisch"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageItalien} style={{height: '20px'}}/>
                                    <div style={props.selectedLanguage?.code === "IT" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Italienisch
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedLanguage({code: "CN", label: "Chinesisch"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageChina} style={{height: '20px'}}/>
                                    <div style={props.selectedLanguage?.code === "CN" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Chinesisch
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedLanguage({code: "JP", label: "Japanisch"})
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageJapan} style={{height: '20px'}}/>
                                    <div style={props.selectedLanguage?.code === "JP" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Japanisch
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedSuitableFor("YOGA")
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageYoga} style={{height: '20px'}}/>
                                    <div style={props.selectedSuitableFor === "YOGA" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Yoga
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedSuitableFor("MINDFULNESS")
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageAchtsamkeit} style={{height: '20px'}}/>
                                    <div style={props.selectedSuitableFor === "MINDFULNESS" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Achtsamkeit
                                    </div>
                                </div>


                                <div
                                    style={{padding: '10px 10px', cursor: 'pointer'}}
                                    onClick={() => {
                                        if(window.location.pathname !== "/") {
                                            navigate("/")
                                        }
                                        props.setSelectedFavorite(false)
                                        props.setSelectedSuitableFor("KOMMUNIKATION")
                                        props.setSearchSwitch("readPanel")
                                    }}>
                                    <img src={ImageKommunikation} style={{height: '20px'}}/>
                                    <div style={props.selectedSuitableFor === "KOMMUNIKATION" ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                        Kommunikation
                                    </div>
                                </div>

                                {/* Sonstiges

                                    <div
                                        style={{padding: '10px 10px', cursor: 'pointer'}}
                                        onClick={() => {
                                            props.setSelectedFavorite(false)
                                            props.setSelectedSuitableFor(null)
                                            if(!isXL) {
                                                setSearchSwitch("readPanel")
                                            }
                                        }}>
                                        <img src={ImageSonstiges} style={{height: '20px'}}/>
                                        <div style={props.selectedSuitableFor === null ? {fontWeight: 'bold', textDecoration: 'underline'} : {}}>
                                            Sonstiges
                                        </div>
                                    </div>
                                    */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div ref={div2Ref}>
            </div>



        </div>
    )
}
